module.exports = __webpack_public_path__ + "0b893952a4090456c1688daceea9f5f4.png";